// Recidiviz - a data platform for criminal justice reform
// Copyright (C) 2025 Recidiviz, Inc.
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
//
// You should have received a copy of the GNU General Public License
// along with this program.  If not, see <https://www.gnu.org/licenses/>.
// =============================================================================

import { Route, Routes } from "react-router-dom";

import { NotFound } from "~@jii/common-ui";
import { useSingleResidentContext } from "~@jii/data";
import { UsAzClassificationPoints, UsAzMoreInformation } from "~@jii/paths";

import { UsAzSingleResidentContextRoute } from "../components/UsAzSingleResidentContext/UsAzSingleResidentContext";
import { PageClassification } from "../pages/PageClassification";
import { PageClassificationFAQ } from "../pages/PageClassificationFAQ";
import { PageMoreInfoAbout } from "../pages/PageMoreInfoAbout";
import { PageMoreInfoDPR } from "../pages/PageMoreInfoDPR";
import { PageMoreInfoImportantDatesV2 } from "../pages/PageMoreInfoImportantDatesV2";
import { PageMoreInfoION } from "../pages/PageMoreInfoION";
import { PageUsAzResidentHome } from "../pages/PageUsAzSingleResidentHome";

export function UsAzRouter() {
  const { residentFlags } = useSingleResidentContext();
  return (
    <Routes>
      <Route element={<UsAzSingleResidentContextRoute />}>
        <Route index element={<PageUsAzResidentHome />} />
        <Route
          path={UsAzMoreInformation.ImportantDates.path}
          element={<PageMoreInfoImportantDatesV2 />}
        />
        <Route
          path={UsAzMoreInformation.About.path}
          element={<PageMoreInfoAbout />}
        />
        <Route
          path={UsAzMoreInformation.DPR.path}
          element={<PageMoreInfoDPR />}
        />
        <Route
          path={UsAzMoreInformation.ION.path}
          element={<PageMoreInfoION />}
        />
        {residentFlags.usAzClassification && (
          <Route path={UsAzClassificationPoints.path}>
            <Route index element={<PageClassification />} />
            <Route
              path={UsAzClassificationPoints.FAQ.path}
              element={<PageClassificationFAQ />}
            />
          </Route>
        )}
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}
